"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStringSize = void 0;
const getStringSize = (str, options = {}) => {
    if (typeof str !== 'string')
        return null;
    // Source: https://jsperf.com/utf-8-byte-length
    let s = str.length;
    for (let i = str.length - 1; i >= 0; i--) {
        const code = str.charCodeAt(i);
        if (code > 0x7f && code <= 0x7ff)
            s++;
        else if (code > 0x7ff && code <= 0xffff)
            s += 2;
        if (options.escapedChars) {
            const escapedCharCodes = options.escapedChars.split('').map(c => c.charCodeAt(0));
            // We count one more byte for each escaped char
            if (escapedCharCodes.includes(code))
                s++;
        }
    }
    return s;
};
exports.getStringSize = getStringSize;
//# sourceMappingURL=getStringSize.js.map